var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Modal",
    {
      staticClass: "panel-featureable-gallery",
      attrs: {
        show: _vm.show,
        title: _vm.modalTitle,
        size: _vm.size,
        needFooter: false,
        needHeader: true,
        centered: true,
        closeBtn: true,
        modalClass: "modal-responsive",
      },
      on: { close: _vm.onClose },
    },
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-12" },
          [
            _c("LayerFeatureableGallery", {
              attrs: {
                show: _vm.show,
                textHeader: _vm.textHeader,
                groups: _vm.groups,
                cardGroupClass: _vm.cardGroupClass,
              },
              on: { selected: _vm.onSelected },
            }),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }